import { StyleProp, ViewStyle } from 'react-native';
import { Text, theme } from '@socrait/react';

import { ColumnConfig } from './types';
import { TableRow } from './TableRow';
import { TableCell } from './TableCell';

interface TableHeaderProps<T> {
  columns: ColumnConfig<T>[];
  columnGap?: number;
  style?: StyleProp<ViewStyle>;
  borderBottomColor?: string;
}

export function TableHeader<T>({
  columns,
  columnGap,
  style,
  borderBottomColor = theme.colors.darkGray,
}: TableHeaderProps<T>) {
  return (
    <TableRow isHeader={true} columnGap={columnGap} style={style}>
      {columns.map((column, index) => (
        <TableCell
          key={index}
          width={column.width}
          align={column.align}
          noBorder={column.noBorder}
          borderBottomColor={borderBottomColor}
          style={column.headerCellStyle}>
          {column.renderHeader ? (
            column.renderHeader()
          ) : typeof column.header === 'string' ? (
            <Text style={column.headerTextStyle}>{column.header}</Text>
          ) : (
            column.header
          )}
        </TableCell>
      ))}
    </TableRow>
  );
}
